/**
 * オブジェクトのコンバータ。
 * 値をそのまま返します。
 * @param  {any} val [description]
 * @return {any}     [description]
 */
export default function ObjectConverter(val) {
    return val;
}



// WEBPACK FOOTER //
// ./src/Converters/ObjectConverter.ts